module.exports = __webpack_public_path__ + "img/close.1b1a2fb3.svg";